
import { AxiosResponse } from 'axios';
import { OAuth2Client } from '@kolorado/oauth';
import { ConfigManagementRequestPayload, QueueConfigRequestPayload } from './types';
import { axiosInstance } from "../axios-instance";
import {deleteConfigManagementResponseBody,QueueConfigManagementResponseBody} from '../entities/config-management-v1/queue-configs-response-body';
import { ConfigManagementResponseBody } from '../entities/config-management-v1/config-management-response-body';

class ConfigurationManagement {
  private authClient: OAuth2Client | null;

  private baseUrl: string;

  constructor(authClient: OAuth2Client | null, baseUrl: string) {
    this.authClient = authClient;
    this.baseUrl = baseUrl;
  }

  queueAssetDeviceConfiguration(
    input: QueueConfigRequestPayload,
    getHeaders:any
  ): Promise<AxiosResponse<QueueConfigManagementResponseBody>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<QueueConfigManagementResponseBody>(`${this.baseUrl}/configs`, input, {
      headers: {
        'Authorization': `Bearer ${accessToken}`,
        'isOverride':getHeaders.isOverride
      },
    
    });
  }

  getConfigurationFiles(
    input: ConfigManagementRequestPayload,
  ): Promise<AxiosResponse<ConfigManagementResponseBody>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.get<ConfigManagementResponseBody>(`${this.baseUrl}/configs`, {
      params: input,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }

  updateAssetDeviceConfiguration(
    input: QueueConfigRequestPayload,
  ): Promise<AxiosResponse<QueueConfigManagementResponseBody>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.patch<QueueConfigManagementResponseBody>(`${this.baseUrl}/configs`, input, {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });
  }

  deleteAssetDeviceConfiguration(
    input: QueueConfigRequestPayload,
  ): Promise<AxiosResponse<deleteConfigManagementResponseBody>> {
    const accessToken = localStorage.getItem('accessToken');
    return axiosInstance.post<deleteConfigManagementResponseBody>(
      `${this.baseUrl}/removeConfigs`,
      input,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );
  }
}

export default ConfigurationManagement;
